import { forwardRef, ElementType } from 'react';

import { Box, BoxProps } from '@mui/material';

import { Icon } from '@iconify/react';

type IconifyProps<T extends ElementType = 'div'> = {
  icon: string;
  size?: number;
  component?: T;
} & BoxProps;

const Iconify = forwardRef<HTMLElement, IconifyProps<ElementType>>(
  (props, ref) => {
    const { icon, size = 24, sx = {}, component = 'div', ...others } = props;

    return (
      <Box
        component={component}
        ref={ref}
        sx={{
          width: size,
          height: size,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          ...sx,
        }}
        {...others}
      >
        <Icon icon={icon} width={size} height={size} />
      </Box>
    );
  }
);

export default Iconify;
